import type { ComponentType } from 'react';

import { Apartment, Grass, HolidayVillage, Home } from '@mui/icons-material';
import type { SvgIconProps } from '@mui/material/SvgIcon';

import { PropertyTypeID } from '@klokhuis/core/ApiClient/Klokhuis';

/** MUI icons for listing / manage cards — keyed by API property type. */
export const listingTypeBadgeIcon: Record<
  PropertyTypeID,
  ComponentType<SvgIconProps>
> = {
  [PropertyTypeID.FarmLand]: Grass,
  [PropertyTypeID.ResidentialLand]: Home,
  [PropertyTypeID.HouseOrVilla]: HolidayVillage,
  [PropertyTypeID.CommercialLand]: Apartment,
};
